import React from 'react';

// Lives here (not packages/shared) so packages/shared/components/dropdown/option.jsx
// doesn't depend on an app-local src/svg/checkmark. Duplicated (intentionally) from
// apps/admin/src/svg/checkmark.tsx, which previously carried a "kept for shared"
// compatibility comment for this exact reason.
// See docs/packages-common-migration/phase-0-findings.md section 6c.
export default function CheckmarkIcon(props) {
  const { color = '#ffffff', height = '8', width = '9', viewBox = `0 0 ${width} ${height}` } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox}>
      <defs>
        <filter id='a' x='0' y='0' filterUnits='userSpaceOnUse'>
          <feOffset dy='1' in='SourceAlpha' />
          <feGaussianBlur result='blurOut' />
          <feFlood floodColor='#000' result='floodOut' />
          <feComposite in='floodOut' in2='blurOut' operator='atop' />
          <feComponentTransfer>
            <feFuncA slope='.21' type='linear' />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in='SourceGraphic' />
          </feMerge>
        </filter>
      </defs>

      <path
        d='M1.771 1.855L0 3.642l3.345 3.361L9 1.323 7.706.001 3.383 3.61 1.771 1.855z'
        fill={color}
        fillRule='evenodd'
        filter='url(#a)'
      />
    </svg>
  );
}
